module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/service/Frame_4108@2x(5).png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fservice%2FFrame_4108%402x(5).png
// module id = MkQ1
// module chunks = 93